import moment from "moment";
const InternationalNumberFormat = new Intl.NumberFormat('en-US',
    { style: "currency", currency: 'USD' })

const showLogs = false;

export const printLogs = (key, value) => {
    if (showLogs) console.log(key, "<====>", value)
}

export const convertDateFormat = (value) => {
    if (value !== null) return moment(value).format('MM/DD/YYYY')
    else return "Not Available"
}

export const convertCurrency = (value) => {
    return InternationalNumberFormat.format(value.toFixed(2))
}

export const getRandomColor = () => Math.floor(Math.random() * 16777215).toString(16);